<template>
  <div class="weui-cells weui-cells_form">
    <h3 class="page__title">购买链点</h3>    
    <h4 class="title">链点（1滴 = ￥0.01）</h4>
    <p style="text-align:left">
      在众敏洗车链中,链点用来进行拉新和复购等营销活动。例如：
      <ol>              
        <li>可以向用户赠送链点，邀请用户来洗车，并使用链点支付洗服务费</li>
        <li>可以在用户完成洗车服务后，按照其支付的服务费返点，鼓励用户再次消费</li>
        <li>可以在用户完成车牌填写后，赠送链点，邀请其体验车牌识别进场洗车</li>
        <li>......</li>
      </ol>
    </p>
    
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">选择额度</label>
        </div>
        <div class="weui-cell__bd" @click="pickAmount">
            <a  style="align-text:left;color: #238E23;">{{amountSelected.label}}</a>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
            <label class="weui-label">链点数量</label>
        </div>
        <div class="weui-cell__bd">
            {{amountSelected.value}}滴
        </div>
    </div>
    <div><br/>正为商户号【{{partnerid}}】充值, 需支付￥{{fenToCNY(amountSelected.value)}}<br/><br/></div>
    <div class="weui-cell weui-cell_active weui-cell_vcode">
        <div class="weui-cell__hd">
        </div>
        <div class="weui-cell__bd">
          <a @click="letsCharge" class="weui-btn weui-btn_primary">充值</a>
        </div>
    </div> 
    <!--   
    <div>
      {{JSON.stringify(rspData)}}
    </div>-->
  </div>        
</template>

<style>
.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>

<script>

import axios from "axios"
import JQ from 'jquery'
import wx from 'jweixin-1.6.0';

export default {
data () {
  return {
    ing:true,
    partnerid:"",
    amountSelected:{
      label: '价值￥200.00的链点',
      value: 20000
    },
    amountList: [
      {
          label: '价值￥20.00的链点',
          value: 2000
      },
      {
          label: '价值￥50.00的链点',
          value: 5000
      },
      {
          label: '价值￥100.00的链点',
          value: 10000
      },
      {
          label: '价值￥200.00的链点',
          value: 20000
      },{
          label: '价值￥500.00的链点',
          value: 50000
      },{
          label: '价值￥3000.00的链点',
          value: 300000
      },{
          label: '价值￥5000.00的链点',
          value: 500000
      }
    ],
    rspData:null
  }
},
mounted() {
     console.log( this.partnerid,sessionStorage.getItem("partnerid"))
     this.partnerid = sessionStorage.getItem("partnerid")
     console.log( this.partnerid,sessionStorage.getItem("partnerid"))
},
methods: {      
  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv); 
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();    
    }else if(intv <= 99){    
      res =  "0."+ ( intv).toString();   
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2) 
    }
    return prefix+res;

  },
  pickAmount() {
    let that = this;
    this.$weui.picker(this.amountList, {
          onChange: function (result) {
              console.log(result);
          },
          onConfirm: function (result) {
              console.log(result);
              that.amountSelected = result[0]
          },
          title: '选择充值数量'
      });
  },
  letsCharge() {
    console.log("letsCharge")
    
    let paras = {};

    paras.partnerId = this.partnerid;
    paras.amount = this.amountSelected.value;

    let that = this;
    axios.post('customer/omc/buyPoints', paras)
    .then(function (response) {
      console.log(response);
      that.rspData = response.data
      that.letsPay();
      

    })
    .catch(function (error) {
      console.log(error);
    });  
  },
  letsPay(){
    console.log("letsPay")
    if(this.rspData.retcode == 0){
      console.log(this.rspData.data.wxJsapiPayRequestInfo)
      let wxJsapiPayRequestInfo = JSON.parse(this.rspData.data.wxJsapiPayRequestInfo);   
      //alert(wxJsapiPayRequestInfo.signType)

      wx.chooseWXPay({
        timestamp: wxJsapiPayRequestInfo.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
        nonceStr: wxJsapiPayRequestInfo.nonceStr, // 支付签名随机串，不长于 32 位
        package: wxJsapiPayRequestInfo.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: wxJsapiPayRequestInfo.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
        paySign: wxJsapiPayRequestInfo.paySign, // 支付签名
        success: function(res) {
          if(res.errMsg === 'chooseWXPay:ok'){               
            alert('充值成功，可以到资产管理查看余额与流水')
          } else{
            alert('支付失败')
          }
        },
        fail: function(res) {
          alert(JSON.stringify(res))
        },
        cancel: function(res) { 
        }
      });
    }else{
      alert("系统繁忙，请稍后再试.")
    }
  }
 }
}
</script>


// WEBPACK FOOTER //
// src/views/ld_charge.vue